import {
  createRouter,
  createWebHistory,
  type NavigationGuardNext,
  type NavigationGuardReturn,
  type RouteLocationNormalized,
  type RouteRecordRaw,
} from 'vue-router';
import DashboardView from '@/views/dashboard/DashboardView.vue';
import HandoverView from '@/views/handover/HandoverView.vue';
import LoginView from '@/views/login/LoginView.vue';
import VerifyEmailView from '@/views/login/VerifyEmailView.vue';
import SettingsViewVue from '@/views/settings/SettingsView.vue';
import UpcomingHandoversView from '@/views/handover/UpcomingHandoversView.vue';
import EditVehicleType from '@/views/vehicle-pool/edit-vehicle-type/EditVehicleType.vue';
import VehicleTypesList from '@/views/vehicle-types/vehicle-types-list/VehicleTypesList.vue';
import EditCar from '@/views/vehicle-pool/edit-car/EditCar.vue';
import EditWorkshopAppointment from '@/views/vehicle-pool/edit-workshop-appointment/EditWorkshopAppointment.vue';
import ViewCar from '@/views/vehicle-types/view-car/ViewCar.vue';
import EditCarStatus from '@/views/vehicle-types/edit-car-status/EditCarStatus.vue';
import HandoverOverview from '@/views/handover/components/overview/HandoverOverview.vue';
import HandoverClientData from '@/views/handover/components/client-data/HandoverClientData.vue';
import HandoverPayment from '@/views/handover/components/payment/HandoverPayment.vue';
import HandoverCarStatus from '@/views/handover/components/car-status/HandoverCarStatus.vue';
import HandoverContract from '@/views/handover/components/contract/HandoverContract.vue';
import InspectionStep from '@/views/handover/components/inspection/InspectionStep.vue';
import { InspectionPhase } from '@carvia/ros-client-types';
import BookingList from '@/views/bookings/bookings-list/BookingsListView.vue';
import BookingsGantt from '@/views/bookings/bookings-gantt-view/BookingsGanttView.vue';
import BookingEdit from '@/views/bookings/booking-edit/BookingEditView.vue';
import BookingCreate from '@/views/bookings/booking-create/BookingCreateView.vue';
import TransferEdit from '@/views/bookings/transfer-edit/TransferEditView.vue';
import ReturnView from '@/views/handover/ReturnView.vue';
import ReturnOverview from '@/views/handover/components/return/return-overview/ReturnOverview.vue';
import HandoverDone from '@/views/handover/components/handover-done/HandoverDone.vue';
import VehicleTypeCarsList from '@/views/vehicle-types/vehicle-type-cars-list/VehicleTypeCarsList.vue';
import CheckConfirmEmailView from '@/views/login/CheckConfirmEmailView.vue';
import ResetPasswordView from '@/views/login/ResetPasswordView.vue';
import ReturnDamages from '@/views/handover/components/return/ReturnDamages.vue';
import ReturnDone from '@/views/handover/components/return/ReturnDone.vue';
import ReturnCarStatus from '@/views/handover/components/return/return-car-status/ReturnCarStatus.vue';
import TransferDetail from '@/views/handover/components/transfer/TransferDetail.vue';
import MaintainanceEdit from '@/views/maintenance/MaintenanceEdit.vue';
import InvoiceListView from '@/views/invoices/invoice-list/InvoiceListView.vue';
import InvoiceView from '@/views/invoices/invoice/InvoiceView.vue';
import CreateInvoiceView from '@/views/invoices/create-invoice/CreateInvoiceView.vue';
import PaymentTerminalListView from '@/views/payment-terminals/payment-terminal-list/PaymentTerminalListView.vue';
import PaymentTerminalView from '@/views/payment-terminals/payment-terminal/PaymentTerminalView.vue';
import BookingEditDamages from '@/views/bookings/booking-edit-damages/BookingEditDamages.vue';
import PartnerRentEdit from '@/views/partner-rent/PartnerRentEdit.vue';
import PartnerRentOverview from '@/views/handover/components/partner-rent/PartnerRentOverview.vue';
import PartnerRentView from '@/views/handover/components/partner-rent/PartnerRentView.vue';
import PartnerRentDone from '@/views/handover/components/partner-rent/PartnerRentDone.vue';
import UserListView from '@/views/users/user-list/UserListView.vue';
import PartnerSubTypeListView from '@/views/users/partner-sub-type-list/PartnerSubTypeListView.vue';
import PartnerSubTypeView from '@/views/users/partner-sub-type/PartnerSubTypeView.vue';
import UserView from '@/views/users/user/UserView.vue';
import ShowNewsView from '@/views/news/show-news/ShowNewsView.vue';
import NewsListView from '@/views/news/news-list/NewsListView.vue';
import LeadsListView from '@/views/leads/LeadsListView.vue';
import EditNewsView from '@/views/news/edit-news/EditNewsView.vue';
import VehiclePoolList from '@/views/vehicle-pool/vehicle-pool-list/VehiclePoolList.vue';
import AddNewCar from '@/views/vehicle-pool/add-new-car/AddNewCar.vue';
import CompleteFleetIn from '@/views/vehicle-pool/complete-fleet-in/CompleteFleetIn.vue';
import HandoverSurvey from '@/views/handover/components/survey/HandoverSurvey.vue';
import StationListView from '@/views/stations/station-list/StationListView.vue';
import StationView from '@/views/stations/station/StationView.vue';
import ReviewView from '@/views/reviews/ReviewView.vue';
import ReviewsListView from '@/views/reviews/ReviewsListView.vue';
import NpsSurveyView from '@/views/nps-surveys/NpsSurveyView.vue';
import InsuranceCasesListView from '@/views/insurance-cases/insurance-cases-list/InsuranceCasesListView.vue';
import CreateInsuranceCaseView from '@/views/insurance-cases/insurance-case/InsuranceCaseView.vue';
import CreateBookingFromInsuranceCase from '@/views/bookings/create-booking-from-insurance-case/CreateBookingFromInsuranceCaseView.vue';
import CouponListView from '@/views/coupons/coupon-list/CouponListView.vue';
import CouponCreateView from '@/views/coupons/coupon-create/CouponCreateView.vue';
import CouponEditView from '@/views/coupons/coupon-edit/CouponEditView.vue';
import EditPricingModifiersView from '@/views/yield-management/edit-pricing-modifiers/EditPricingModifiersView.vue';
import YieldManagementView from '@/views/yield-management/YieldManagementView.vue';
import EditExtrasView from '@/views/yield-management/edit-extras/EditExtrasView.vue';
import EditYieldManagementKmView from '@/views/yield-management/yield-management-settings/EditYieldManagementKmView.vue';
import EditYieldManagementOtherView from '@/views/yield-management/yield-management-settings/EditYieldManagementOtherView.vue';
import AreaChargesView from '@/views/yield-management/area-charges/AreaChargesView.vue';
import QueueInspectorView from '@/views/queue-inspector/QueueInspectorView.vue';
import SwapView from '@/views/handover/SwapView.vue';
import SwapReturnOverview from '@/views/handover/components/swap/SwapReturnOverview.vue';
import SwapReturnStatus from '@/views/handover/components/swap/SwapReturnStatus.vue';
import SwapHandoverStatus from '@/views/handover/components/swap/SwapHandoverStatus.vue';
import SwapInspection from '@/views/handover/components/swap/SwapInspection.vue';
import SwapProtocol from '@/views/handover/components/swap/SwapProtocol.vue';
import SwapDone from '@/views/handover/components/swap/SwapDone.vue';
import ApprovalRequestsView from '@/views/approval-requests/ApprovalRequestsView.vue';
import ApprovalRequestDetailView from '@/views/approval-requests/ApprovalRequestDetailView.vue';
import TrainingVideosView from '@/views/training-videos/TrainingVideosView.vue';
import MediaView from '@/views/media/MediaView.vue';
import ReceivablesView from '@/views/receivables/ReceivablesView.vue';
import PaymentView from '@/views/payments/PaymentView.vue';
import DeviceRoleView from '@/views/device/DeviceRoleView.vue';
import VideoWallView from '@/views/device/VideoWallView.vue';
import type { CanParameters } from '@casl/ability';
import type { RosAbilities } from '@/entities/auth/abilities';
import { clearLanguageSession } from '@/hooks/apply-language-for-session';
import { queryClient } from '@/queries/query-client';
import {
  abilitiesOptions,
  applyLoggedInUserLanguage,
  tokenPayloadOptions,
} from '@/queries/auth/use-login';
import { ROLES_ALLOWED_TO_USE_APP } from '@/utils/roles-allowed-to-use-app';
import { ability } from '@/main';
import type { JWTUser } from '@/entities/auth/jwt-user.entity';
import type { JwtDeviceDto } from '@carvia/ros-client-types';
import InfringementsListView from '@/views/infringements/infringements-list/InfringementsListView.vue';
import InfringementDetailView from '@/views/infringements/infringement-detail/InfringementDetailView.vue';

export type RouterMeta = {
  requireAuth?: boolean | [CanParameters<RosAbilities>[0], CanParameters<RosAbilities>[1]][];
  public?: boolean;
};

const routes: readonly (RouteRecordRaw & { meta?: RouterMeta })[] = [
  {
    name: 'home',
    path: '/',
    component: DashboardView,
    meta: {
      requireAuth: [['ros', 'Dashboard']],
    },
  },
  {
    name: 'login',
    path: '/login',
    component: LoginView,
  },
  {
    name: 'deviceRole',
    path: '/device-role',
    component: DeviceRoleView,
    meta: {
      requireAuth: true,
    },
  },
  {
    name: 'videoWall',
    path: '/video-wall/:stationSlug',
    component: VideoWallView,
    meta: {
      public: true,
    },
  },
  {
    name: 'resetPassword',
    path: '/reset-password',
    component: ResetPasswordView,
  },

  {
    name: 'checkConfirmEmail',
    path: '/check-confirm-email',
    component: CheckConfirmEmailView,
  },
  {
    name: 'verifyemail',
    path: '/verify-email',
    component: VerifyEmailView,
    children: [
      {
        name: 'verifyEmail',
        path: ':verificationCode',
        component: VerifyEmailView,
      },
    ],
  },

  {
    name: 'upcomingHandovers',
    path: '/upcoming-handovers',
    component: UpcomingHandoversView,
    meta: {
      requireAuth: [['handle', 'Booking']],
    },
  },
  {
    name: 'workshopAppointmentHandover',
    path: '/workshop-appointments/:workshopAppointmentId/handover',
    component: () =>
      import('@/views/handover/workshop-appointment/WorkshopAppointmentHandoverView.vue'),
    meta: {
      requireAuth: [['handle', 'Booking']],
    },
  },
  {
    name: 'workshopAppointmentReturn',
    path: '/workshop-appointments/:workshopAppointmentId/return',
    component: () =>
      import('@/views/handover/workshop-appointment/WorkshopAppointmentReturnView.vue'),
    meta: {
      requireAuth: [['handle', 'Booking']],
    },
  },
  {
    name: 'handover',
    path: '/handover',
    component: HandoverView,
    meta: {
      requireAuth: [['handle', 'Booking']],
    },
    children: [
      {
        name: 'handoverDetail',
        path: ':id',
        component: HandoverOverview,
      },
      {
        name: 'handoverSurvey',
        path: ':id/:surveyId',
        component: HandoverSurvey,
      },
      {
        name: 'handoverClientData',
        path: ':id/client-data',
        component: HandoverClientData,
      },
      {
        name: 'handoverPayment',
        path: ':id/payment',
        component: HandoverPayment,
      },
      {
        name: 'handoverCarStatus',
        path: ':id/vehicle-status',
        component: HandoverCarStatus,
      },
      {
        name: 'handoverInspection',
        path: ':id/vehicle-photos',
        component: InspectionStep,
        props: { phase: InspectionPhase.HANDOVER },
      },
      {
        name: 'handoverRentalContract',
        path: ':id/contract',
        component: HandoverContract,
      },
      {
        name: 'handoverDone',
        path: ':id/finished',
        component: HandoverDone,
      },
    ],
  },
  {
    name: 'return',
    path: '/return',
    component: ReturnView,
    meta: {
      requireAuth: [['handle', 'Booking']],
    },
    children: [
      {
        name: 'returnOverview',
        path: ':id',
        component: ReturnOverview,
      },
      {
        name: 'returnDamages',
        path: ':id/damages',
        component: ReturnDamages,
      },
      {
        name: 'returnCarStatus',
        path: ':id/car-status',
        component: ReturnCarStatus,
      },
      {
        name: 'returnInspection',
        path: ':id/vehicle-photos',
        component: InspectionStep,
        props: { phase: InspectionPhase.RETURN },
      },
      {
        name: 'returnDone',
        path: ':id/done',
        component: ReturnDone,
      },
    ],
  },
  {
    name: 'swap',
    path: '/swap/:bookingId',
    component: SwapView,
    meta: {
      requireAuth: [['handle', 'Booking']],
    },
    children: [
      {
        name: 'swapReturnOverview',
        path: '',
        component: SwapReturnOverview,
      },
      {
        name: 'swapReturnInspection',
        path: 'return-vehicle-photos',
        component: SwapInspection,
        props: { phase: InspectionPhase.RETURN },
      },
      {
        name: 'swapReturnStatus',
        path: 'return-status',
        component: SwapReturnStatus,
      },
      {
        name: 'swapHandoverStatus',
        path: 'handover-status',
        component: SwapHandoverStatus,
      },
      {
        name: 'swapInspection',
        path: 'vehicle-photos',
        component: SwapInspection,
        props: { phase: InspectionPhase.HANDOVER },
      },
      {
        name: 'swapProtocol',
        path: 'protocol',
        component: SwapProtocol,
      },
      {
        name: 'swapDone',
        path: 'done',
        component: SwapDone,
      },
    ],
  },
  {
    name: 'transferDetail',
    path: '/transfer/:id',
    meta: {
      requireAuth: [['handle', 'Booking']],
    },
    component: TransferDetail,
  },

  {
    name: 'bookingList',
    path: '/booking-list',
    component: BookingList,
    meta: {
      requireAuth: [['list', 'Booking']],
    },
  },
  {
    name: 'bookingEdit',
    path: '/booking-list/:id',
    component: BookingEdit,
    meta: {
      requireAuth: [['list', 'Booking']],
    },
  },
  {
    name: 'bookingCreate',
    path: '/booking-create',
    component: BookingCreate,
    meta: {
      requireAuth: [['ros', 'CreateBooking']],
    },
  },
  {
    name: 'createBookingFromInsuranceCase',
    path: '/create-booking-from-insurance-case/:id',
    component: CreateBookingFromInsuranceCase,
    meta: {
      requireAuth: [['ros', 'CreateBooking']],
    },
  },
  {
    name: 'bookingEditDamages',
    path: '/booking-list/:id/damages',
    component: BookingEditDamages,
    meta: {
      requireAuth: [['list', 'Booking']],
    },
  },
  {
    name: 'bookingPlan',
    path: '/booking-plan',
    component: BookingsGantt,
    meta: {
      requireAuth: [['list', 'Allocation']],
    },
  },
  {
    name: 'bookingPlanEdit',
    path: '/booking-plan/:id',
    component: BookingEdit,
    meta: {
      requireAuth: [['list', 'Allocation']],
    },
  },
  {
    name: 'transferEdit',
    path: '/transfer-edit/:transferType/:allocationId/:transferId',
    component: TransferEdit,
    meta: {
      requireAuth: [['update', 'Allocation']],
    },
  },
  {
    name: 'insuranceCasesList',
    path: '/insurance-cases-list',
    component: InsuranceCasesListView,
    meta: {
      requireAuth: [['manage', 'InsuranceCase']],
    },
  },
  {
    name: 'insuranceCase',
    path: '/insurance-case/:id',
    component: CreateInsuranceCaseView,
    meta: {
      requireAuth: [['manage', 'InsuranceCase']],
    },
  },
  {
    name: 'vehicleTypes',
    path: '/vehicle-types',
    component: VehicleTypesList,
    meta: {
      requireAuth: [['read', 'VehicleType']],
    },
  },
  {
    name: 'vehicleTypeCarsList',
    path: '/vehicle-type-cars-list/:id',
    component: VehicleTypeCarsList,
    meta: {
      requireAuth: [['read', 'VehicleType']],
    },
  },
  {
    name: 'viewCar',
    path: '/view-car/:id',
    component: ViewCar,
    meta: {
      requireAuth: [['get', 'Car']],
    },
  },
  {
    name: 'editCar',
    path: '/edit-car/:id',
    component: EditCar,
    meta: {
      requireAuth: [['manage', 'Car']],
    },
  },
  {
    name: 'editWorkshopAppointment',
    path: '/workshop-appointments/:id/edit',
    component: EditWorkshopAppointment,
    meta: {
      requireAuth: [['manage', 'WorkshopAppointment']],
    },
  },
  {
    name: 'editVehicleType',
    path: '/edit-vehicle-type/:id',
    component: EditVehicleType,
    meta: {
      requireAuth: [['manage', 'VehicleType']],
    },
  },
  {
    name: 'editCarStatus',
    path: '/car-status/:id/:autoEnterMilage?',
    component: EditCarStatus,
    meta: {
      requireAuth: [['update', 'Car']],
    },
  },
  {
    name: 'vehiclePool',
    path: '/vehicle-pool',
    component: VehiclePoolList,
    meta: {
      requireAuth: [['ros', 'VehiclePool']],
    },
  },
  {
    name: 'addNewCar',
    path: '/add-new-car/:vehicleTypeId?',
    component: AddNewCar,
    meta: {
      requireAuth: [['create', 'Car']],
    },
  },
  {
    name: 'completeCarFleetIn',
    path: '/complete-car-fleet-in/:id',
    component: CompleteFleetIn,
    meta: {
      requireAuth: [['manage', 'Car']],
    },
  },
  {
    name: 'settings',
    path: '/settings',
    component: SettingsViewVue,
    meta: {
      requireAuth: true,
    },
  },
  {
    name: 'maintenanceEdit',
    path: '/maintenance-edit/:carId/:blockId',
    component: MaintainanceEdit,
    meta: {
      requireAuth: [
        ['get', 'Allocation'],
        ['view', 'Allocation'],
      ],
    },
  },
  {
    name: 'partnerRentEdit',
    path: '/partner-rent-edit/:carId/:allocationId',
    component: PartnerRentEdit,
    meta: {
      requireAuth: [
        ['get', 'Allocation'],
        ['view', 'Allocation'],
      ],
    },
  },
  {
    name: 'partnerRentHandoverView',
    path: '/partner-rent-handover-view',
    component: PartnerRentView,
    meta: {
      requireAuth: [['handle', 'Booking']],
    },
    children: [
      {
        name: 'partnerRentHandover',
        path: '/partner-rent-handover/:id',
        component: PartnerRentOverview,
        meta: {
          requireAuth: [['handle', 'Booking']],
        },
      },
      {
        name: 'partnerRentHandoverDone',
        path: '/partner-rent-handover-done/:handedOverOrReturned',
        component: PartnerRentDone,
        meta: {
          requireAuth: [['handle', 'Booking']],
        },
      },
    ],
  },
  {
    name: 'invoiceList',
    path: '/invoice-list',
    component: InvoiceListView,
    meta: {
      requireAuth: [['manage', 'Invoice']],
    },
  },
  {
    name: 'receivables',
    path: '/receivables',
    component: ReceivablesView,
    meta: {
      requireAuth: [['ros', 'Receivables']],
    },
  },
  {
    name: 'payment',
    path: '/payment/:id',
    component: PaymentView,
    meta: {
      requireAuth: [['get', 'Payment']],
    },
  },
  {
    name: 'invoice',
    path: '/invoice/:id',
    component: InvoiceView,
    meta: {
      requireAuth: [['manage', 'Invoice']],
    },
  },
  {
    name: 'createInvoice',
    path: '/create-invoice',
    component: CreateInvoiceView,
    meta: {
      requireAuth: [['create', 'Invoice']],
    },
  },
  {
    name: 'paymentTerminalList',
    path: '/payment-terminal-list',
    component: PaymentTerminalListView,
    meta: {
      requireAuth: [['manage', 'PaymentTerminal']],
    },
  },
  {
    name: 'paymentTerminal',
    path: '/payment-terminal/:id',
    component: PaymentTerminalView,
    meta: {
      requireAuth: [['manage', 'PaymentTerminal']],
    },
  },
  {
    name: 'userList',
    path: '/user-list',
    component: UserListView,
    meta: {
      requireAuth: [['manage', 'User']],
    },
  },
  {
    name: 'partnerSubTypeList',
    path: '/partner-sub-type-list',
    component: PartnerSubTypeListView,
    meta: {
      requireAuth: [['manage', 'PartnerSubType']],
    },
  },
  {
    name: 'partnerSubType',
    path: '/partner-sub-type/:id',
    component: PartnerSubTypeView,
    meta: {
      requireAuth: [['manage', 'PartnerSubType']],
    },
  },
  {
    name: 'user',
    path: '/user/:id',
    component: UserView,
    meta: {
      requireAuth: [['create', 'User']],
    },
  },
  {
    name: 'showNews',
    path: '/show-news/:id',
    component: ShowNewsView,
    meta: {
      requireAuth: [['read', 'News']],
    },
  },
  {
    name: 'infringementsList',
    path: '/infringements',
    component: InfringementsListView,
    meta: {
      requireAuth: [['manage', 'Infringement']],
    },
  },
  {
    name: 'infringementDetail',
    path: '/infringements/:id',
    component: InfringementDetailView,
    meta: {
      requireAuth: [['manage', 'Infringement']],
    },
  },
  {
    name: 'leadsList',
    path: '/leads',
    component: LeadsListView,
    meta: {
      requireAuth: [['manage', 'Lead']],
    },
  },
  {
    name: 'newsList',
    path: '/news-list',
    component: NewsListView,
    meta: {
      requireAuth: [['read', 'News']],
    },
  },
  {
    name: 'editNews',
    path: '/edit-news/:id',
    component: EditNewsView,
    meta: {
      requireAuth: [['manage', 'News']],
    },
  },
  {
    name: 'stationList',
    path: '/station-list',
    component: StationListView,
    meta: {
      requireAuth: [['manage', 'Station']],
    },
  },
  {
    name: 'station',
    path: '/station/:id',
    component: StationView,
    meta: {
      requireAuth: [['manage', 'Station']],
    },
  },
  {
    name: 'review',
    path: '/review/:id',
    component: ReviewView,
    meta: {},
  },
  {
    name: 'reviews',
    path: '/reviews',
    component: ReviewsListView,
    meta: {
      requireAuth: [['list', 'Review']],
    },
  },
  {
    name: 'nps-survey',
    path: '/nps-survey/:id',
    component: NpsSurveyView,
    meta: {},
  },
  {
    name: 'couponList',
    path: '/coupons',
    component: CouponListView,
    meta: {
      requireAuth: [['read', 'Coupon']],
    },
  },
  {
    name: 'couponCreate',
    path: '/coupons/create',
    component: CouponCreateView,
    meta: {
      requireAuth: [['create', 'Coupon']],
    },
  },
  {
    name: 'couponEdit',
    path: '/coupons/:id',
    component: CouponEditView,
    meta: {
      requireAuth: [['update', 'Coupon']],
    },
  },
  {
    name: 'yieldManagement',
    path: '/yield-management',
    component: YieldManagementView,
    meta: {
      requireAuth: [['ros', 'YieldManagement']],
    },
  },
  {
    name: 'editPricingModifiers',
    path: '/edit-pricing-modifiers',
    component: EditPricingModifiersView,
    meta: {
      requireAuth: [['manage', 'PricingModifier']],
    },
  },
  {
    name: 'editExtras',
    path: '/edit-extras',
    component: EditExtrasView,
    meta: {
      requireAuth: [['manage', 'VehicleExtra']],
    },
  },
  {
    name: 'editYieldManagementKm',
    path: '/edit-yield-management-km',
    component: EditYieldManagementKmView,
    meta: {
      requireAuth: [['manage', 'YieldManagementSettings']],
    },
  },
  {
    name: 'editYieldManagementOther',
    path: '/edit-yield-management-other',
    component: EditYieldManagementOtherView,
    meta: {
      requireAuth: [['manage', 'YieldManagementSettings']],
    },
  },
  {
    name: 'areaCharges',
    path: '/yield-management/area-charges',
    component: AreaChargesView,
    meta: {
      requireAuth: [['manage', 'YieldManagementSettings']],
    },
  },
  {
    path: '/queue-inspector',
    name: 'queueInspector',
    component: QueueInspectorView,
    meta: {
      requireAuth: [['ros', 'QueueInspector']],
    },
  },
  {
    name: 'approvalRequests',
    path: '/approval-requests',
    component: ApprovalRequestsView,
    meta: {
      requireAuth: [['manage', 'ApprovalRequest']],
    },
  },
  {
    name: 'approvalRequest',
    path: '/approval-requests/:id',
    component: ApprovalRequestDetailView,
    meta: {
      requireAuth: [['manage', 'ApprovalRequest']],
    },
  },
  {
    name: 'trainingVideos',
    path: '/training-videos',
    component: TrainingVideosView,
    meta: {
      requireAuth: [['read', 'Video']],
    },
  },
  {
    name: 'media',
    path: '/media',
    component: MediaView,
    meta: {
      requireAuth: [['read', 'Media']],
    },
  },
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.query.tab && from.query.tab) {
      return false;
    } else {
      return { top: 0 };
    }
  },
});

let initialRoute = true;

router.beforeResolve(
  async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext,
  ): Promise<NavigationGuardReturn> => {
    if (to.path === from.path && !initialRoute) return next();
    initialRoute = false;

    const meta = to.meta as RouterMeta;

    if (!meta.requireAuth) {
      return next();
    }

    const rerouting = await requireAuth(
      typeof meta.requireAuth === 'boolean' ? undefined : meta.requireAuth,
    );
    if (rerouting) {
      if ('name' in rerouting && rerouting.name === to.name) {
        return next();
      }
      return next(rerouting);
    }
    return next();
  },
);

const requireAuth = async (
  restrictions?: [CanParameters<RosAbilities>[0], CanParameters<RosAbilities>[1]][],
) => {
  try {
    const tokenPayload = await queryClient.ensureQueryData(tokenPayloadOptions);
    if (isDeviceTokenPayload(tokenPayload)) {
      return { name: 'deviceRole' };
    }
    if (!isJWTUserTokenPayload(tokenPayload)) {
      return loginRoute();
    }
    await queryClient.ensureQueryData(abilitiesOptions);
    if (!ROLES_ALLOWED_TO_USE_APP.includes(tokenPayload.role)) {
      return loginRoute();
    }
    try {
      await applyLoggedInUserLanguage(tokenPayload.id);
    } catch {
      // Profile language is optional; a failed read must not block the app.
    }
    if (!tokenPayload.isEmailConfirmed) {
      return { name: 'checkConfirmEmail' };
    }
    if (restrictions?.some((restriction) => !ability.can(...restriction))) {
      if (ability.can('ros', 'Dashboard')) {
        return { name: 'home' };
      } else {
        return loginRoute();
      }
    }
    return;
  } catch (error) {
    return loginRoute();
  }
};

function loginRoute() {
  clearLanguageSession();
  return { name: 'login' as const };
}

function isDeviceTokenPayload(payload: unknown): payload is JwtDeviceDto {
  return !!payload && typeof payload === 'object' && 'deviceRole' in payload;
}

function isJWTUserTokenPayload(payload: unknown): payload is JWTUser {
  return !!payload && typeof payload === 'object' && 'role' in payload;
}

export default router;
